import { platformSystemNotificationHealthResponseSchema, platformSystemNotificationMarkAllResponseSchema, platformSystemNotificationMarkOneResponseSchema, platformSystemNotificationMarkRequestSchema, platformSystemNotificationsListQuerySchema, platformSystemNotificationsListResponseSchema, platformSystemNotificationsUnreadCountResponseSchema, } from '@crest/platform-contracts';
import { z } from 'zod';
const uuidSchema = z.string().uuid();
export class PlatformSystemNotificationApiClient {
    api;
    constructor(api) {
        this.api = api;
    }
    async list(input) {
        const query = platformSystemNotificationsListQuerySchema.parse({
            limit: input.limit,
            ...(input.cursor === undefined ? {} : { cursor: input.cursor }),
        });
        const search = new URLSearchParams({ limit: String(query.limit) });
        if (query.cursor !== undefined)
            search.set('cursor', query.cursor);
        const response = await this.api.request(`/api/v1/platform/system-notifications?${search.toString()}`, platformSystemNotificationsListResponseSchema, { signal: input.signal });
        return { data: response.data, nextCursor: response.nextCursor };
    }
    async unreadCount(signal) {
        const response = await this.api.request('/api/v1/platform/system-notifications/unread-count', platformSystemNotificationsUnreadCountResponseSchema, { signal });
        return response.data.unreadCount;
    }
    async markOne(notificationId, commandId, signal) {
        const target = uuidSchema.parse(notificationId);
        const body = platformSystemNotificationMarkRequestSchema.parse({ commandId });
        const response = await this.api.request(`/api/v1/platform/system-notifications/${target}/read`, platformSystemNotificationMarkOneResponseSchema, { method: 'PATCH', body: JSON.stringify(body), signal });
        return response.data;
    }
    async markAll(commandId, signal) {
        const body = platformSystemNotificationMarkRequestSchema.parse({ commandId });
        const response = await this.api.request('/api/v1/platform/system-notifications/read-all', platformSystemNotificationMarkAllResponseSchema, { method: 'PATCH', body: JSON.stringify(body), signal });
        return response.data;
    }
    async operationsHealth(signal) {
        const response = await this.api.request('/api/v1/platform/system-notifications/operations/health', platformSystemNotificationHealthResponseSchema, { signal });
        return response.data;
    }
}
//# sourceMappingURL=platform-system-notification.api-client.js.map